import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Mission } from "@/components/Mission";
import { Programs } from "@/components/Programs";
import { About } from "@/components/About";
import { GetInvolved } from "@/components/GetInvolved";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <div className="bg-[#0b0d10] min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Mission />
        <Programs />
        <About />
        <GetInvolved />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
